import Row from "./Row";

const NO_DATA_MSG = "No Data to Show";

const Table = (props) => {
  const rows = props.tableData.row;

  const visibleCols = [];
  const columns = props.tableData.column.filter((col) => {
    if (col.visible) visibleCols.push(col.value);
    return col.visible;
  });

  console.log("columnscolumns", columns);

  return (
    <>
      <div className="row mt-4">
        <div className="col">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      className={
                        [
                          "op_stk",
                          "in_qty",
                          "out_qty",
                          "cl_stk",
                          "op_st",
                          "pur",
                          "sales",
                          "pur_rtn",
                          "sales_rtn",
                          "adjustment_in",
                          "adjustment_out",
                          "cl_st",
                          "chal_amt",
                          "exp_amt",
                          "inc_amt",
                          "trans_amount",
                          "qty",
                          "rate",
                          "amount",
                          "total_amount",
                          "chal_rtn_amt",
                          "challan_qty",
                          "wd_amt",
                          "cr_amount",
                          "dr_amount",
                          "return_amt",
                          "final_amt",
                        ].includes(col.value)
                          ? "text-end"
                          : ""
                      }
                    >
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              {/* <tbody>
                                {rows.length
                                    ? rows.map(row => (<Row row={row} cols={visibleCols} handler={{ getList: props.handler.getList }} />))
                                    : <td colSpan={columns.length} className="text-center">{NO_DATA_MSG}</td>
                                }
                            </tbody> */}
              <tbody>
                {rows.length ? (
                  rows.map((row, index) => (
                    <Row
                      key={index}
                      row={row}
                      cols={visibleCols}
                      handler={{ getList: props.handler.getList }}
                      index={index}
                      filter={props?.filter}
                    />
                  ))
                ) : (
                  <td colSpan={columns.length} className="text-center">
                    {NO_DATA_MSG}
                  </td>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Table;
